import styled from "styled-components";

/**
 * 폼 푸터 공용 버튼 (취소/제출).
 *
 * 기존에 각 등록/편집 화면이 따로 정의하던 Cancel/Submit styled 버튼을 통일한 것.
 * 마진은 화면마다 달라 포함하지 않으며, 필요한 곳에서 style로 보존한다.
 */

// 취소 버튼 (흰 배경 / 검은 글씨)
export const CancelButton = styled.button`
  display: flex;
  width: 153px;
  height: 42px;
  padding: 10px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 5px;
  border: 1px solid var(--admin-gray-stroke, #e8e8e8);
  background-color: var(--white, #fff);
  color: var(--black, #000);
  font-family: "Noto Sans KR";
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 140%;
  cursor: pointer;
`;

/**
 * 제출 버튼 (활성→파랑, 비활성→회색, 항상 흰 글씨).
 * @prop $active - 값이 주어졌고 falsy(false/""/0/null)면 비활성(회색/not-allowed).
 *                 생략(undefined) 시 활성으로 간주.
 *
 * 주의: `title && images` 같은 식은 미입력 시 false가 아닌 ""·undefined를 반환하므로
 * `$active === false`만 보면 색이 바뀌지 않는다. 아래처럼 "값이 있는데 falsy"로 판정한다.
 */
const isInactive = ({ $active }) => $active !== undefined && !$active;

export const SubmitButton = styled.button`
  display: flex;
  width: 153px;
  height: 42px;
  padding: 10px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 5px;
  border: none;
  color: var(--white, #fff);
  font-family: "Noto Sans KR";
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 140%;
  cursor: ${(props) => (isInactive(props) ? "not-allowed" : "pointer")};
  background-color: ${(props) => (isInactive(props) ? "#cfd4d9" : "#0079e0")};
`;
